import { createContext, useContext, useMemo } from 'react'
import service from '../../../@services'
import { procurementTypeEnum, purchaseTypeMap } from '../config'

export const ProcurementType = createContext({procurementType: procurementTypeEnum[0], purchaseOrderNo: null,})

export default function useProcurementTypeContext() {
  const { procurementType, purchaseOrderNo} = useContext(ProcurementType)
  const { isOrder, procurementTypeText, requestBaseModule, baseKey } =
    useMemo(() => {
      const _isOrder = procurementType === procurementTypeEnum[0]
      return {
        purchaseOrderNo: purchaseOrderNo,
        isOrder: _isOrder,
        procurementTypeText: purchaseTypeMap[procurementType],
        requestBaseModule: _isOrder
          ? service.purchaseOrder
          : service.purchaseReturn,
        baseKey: _isOrder ? '/purchase-order/' : '/purchase-return/'
      }
    }, [procurementType])
  return {
    procurementType,
    procurementTypeText,
    requestBaseModule,
    isOrder,
    baseKey,
    purchaseOrderNo
  }
}
